<script setup lang="ts">
    import { useAppStore } from '#imports';

    /* Store variables */
    const { isMenu, isMobile, txt } = storeToRefs(useAppStore());
</script>

<template>
    <v-layout>
        <AppBar />
        <NavDrawer />
        <v-main class="w-100">
            <v-container
                :class="isMobile ? 'px-0' : ''"
                fluid
                max-width="995"
                style="margin-bottom: 64px;">
                <slot></slot>
            </v-container>
            <Footer />
        </v-main>
    </v-layout>
</template>